import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "10.5",
      cy: "11",
      r: "10.5"
    }, null, -1),
    _createElementVNode("path", { d: "M15.205 8.738a.42.42 0 0 1 .128.315.4.4 0 0 1-.035.17.5.5 0 0 1-.098.146l-3.11 3.112a.442.442 0 1 1-.627-.627l2.355-2.356H6.891a.446.446 0 0 1-.444-.445c0-.244.2-.444.444-.444h6.927l-2.35-2.352a.443.443 0 1 1 .626-.627z" }, null, -1),
    _createElementVNode("path", { d: "M6.129 13.627a.43.43 0 0 0-.129.315q0 .088.036.17a.5.5 0 0 0 .097.146l3.11 3.112a.442.442 0 1 0 .627-.627l-2.355-2.356h6.927a.446.446 0 0 0 0-.89H7.515l2.35-2.351a.443.443 0 1 0-.626-.627z" }, null, -1)
  ]))]))
}
export default { render: render }